import styled, { css, keyframes } from 'styled-components';
import { StyledCardHeader } from './components/DialogHeader.js';
import { unit } from '../v2/foundation/spacing/utils.js';
import { Card } from '../v2/dataDisplay/Card/Card.js';
import { breakpoint } from '../deprecated/theme/breakpoints/values.js';

var sizes = new Map([['small', unit(120)], ['compact', unit(180)], ['large', unit(240)]]);
var disableHeaderShadow = css(["", "{box-shadow:none;}"], StyledCardHeader);
var slideUpIn = keyframes(["0%{opacity:0;transform:translateY(", ");}80%{opacity:1;}100%{transform:translateY(0);}"], unit(6));
var StyledCard = styled(Card).withConfig({
  displayName: "StyledCard",
  componentId: "sc-tr0a67-0"
})(["flex:1;width:100vw;height:100vh;height:-webkit-fill-available;margin:0;@media ", "{border-radius:0;box-shadow:none;}@media ", "{max-width:", ";width:80vw;height:auto;max-height:80vh;margin:10vh auto;", " ", ";}"], breakpoint.portable, breakpoint.desk, function (props) {
  return sizes.get(props.$size);
}, function (_ref) {
  var $animate = _ref.$animate;
  return $animate && css(["animation:0.5s ", " forwards;"], slideUpIn);
}, function (props) {
  return props.$size === 'small' && disableHeaderShadow;
});

export { StyledCard };
